import { Link, useLocation } from "react-router-dom";
import { MOBILE_NAV } from "../../lib/labs-config";
import { cn } from "../../lib/utils";

export default function MobileNav({ onCopilot }) {
  const location = useLocation();
  return (
    <nav
      data-testid="mobile-nav"
      className="lg:hidden fixed bottom-0 inset-x-0 z-40 px-3 pb-3 pt-2"
    >
      <div
        className="flex items-center justify-between rounded-2xl pl-glass px-2 py-1.5"
        style={{ boxShadow: "0 -8px 32px -8px var(--pl-glow)" }}
      >
        {MOBILE_NAV.map((item) => {
          const Active = location.pathname === item.to;
          const Icon = item.icon;
          if (item.action === "copilot") {
            return (
              <button
                key={item.id}
                onClick={onCopilot}
                data-testid="mobile-copilot-btn"
                className="flex flex-col items-center gap-0.5 px-3 py-1.5 -mt-6 rounded-2xl pl-btn-aqua text-[#061414]"
              >
                <Icon className="h-5 w-5" />
                <span className="text-[10px] font-semibold">{item.label}</span>
              </button>
            );
          }
          return (
            <Link
              key={item.id}
              to={item.to}
              data-testid={`mobile-link-${item.id}`}
              className={cn(
                "flex flex-col items-center gap-0.5 px-3 py-2 rounded-xl transition",
                Active
                  ? "text-[var(--pl-aqua)]"
                  : "text-[var(--pl-text-muted)] hover:text-[var(--pl-text)]"
              )}
            >
              <Icon className="h-5 w-5" strokeWidth={1.7} />
              <span className="text-[10px] font-medium">{item.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
